import { render, staticRenderFns } from "./BgWrap.vue?vue&type=template&id=2c9ad764&scoped=true&"
import script from "./BgWrap.vue?vue&type=script&lang=js&"
export * from "./BgWrap.vue?vue&type=script&lang=js&"
import style0 from "./BgWrap.vue?vue&type=style&index=0&id=2c9ad764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ad764",
  null
  
)

export default component.exports